import { useEffect, useRef, useState } from 'react';

const partners = [
  { name: 'FedNow', sub: 'Federal Reserve', accent: true },
  { name: 'ICBA', sub: 'Ind. Community Bankers' },
  { name: 'ABA', sub: 'American Bankers Assoc.' },
  { name: 'FDIC', sub: 'Insured' },
  { name: 'NACHA', sub: 'ACH Network' },
  { name: 'FIS', sub: 'Core Banking' },
  { name: 'Finastra', sub: 'Open Banking' },
];

export default function LogoBar() {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setRevealed(true); obs.disconnect(); } },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-testid="logo-bar"
      className="relative border-y border-[#1A1A1A] py-8 overflow-hidden"
      style={{ background: '#050505' }}
    >
      {/* scan line */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(0,255,0,0.3) 50%, transparent 100%)' }}
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-0">
          {/* Label */}
          <div
            className="flex-shrink-0 sm:pr-8 sm:mr-8 sm:border-r sm:border-[#1A1A1A] text-center sm:text-left"
            style={{
              opacity: revealed ? 1 : 0,
              transition: 'opacity 0.6s ease',
            }}
          >
            <div className="text-[#00FF00] font-mono text-[10px] uppercase tracking-[0.4em] whitespace-nowrap">
              Built on &amp; Compatible with
            </div>
          </div>

          {/* Logos */}
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-6 sm:gap-8 flex-1">
            {partners.map((p, i) => (
              <div
                key={p.name}
                data-testid={`logo-bar-item-${i}`}
                className="flex flex-col items-center gap-0.5 group"
                style={{
                  opacity: revealed ? 1 : 0,
                  transform: revealed ? 'translateY(0)' : 'translateY(8px)',
                  transition: `all 0.5s ease ${0.05 + i * 0.07}s`,
                }}
              >
                <span
                  className="font-black uppercase leading-none tracking-tighter group-hover:text-[#00FF00] transition-colors duration-300"
                  style={{
                    fontFamily: 'Unbounded, sans-serif',
                    fontSize: '13px',
                    color: p.accent ? '#00FF00' : '#444',
                    textShadow: p.accent ? '0 0 12px rgba(0,255,0,0.35)' : 'none',
                    letterSpacing: '-0.03em',
                  }}
                >
                  {p.name}
                </span>
                <span
                  className="font-mono text-[8px] uppercase tracking-widest text-[#333] group-hover:text-[#555] transition-colors duration-300 whitespace-nowrap"
                >
                  {p.sub}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
